import { createApp } from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less';
import apiAxios from '../../../config/request.js'

const app = createApp(App);
app.config.globalProperties.$apiRequest = apiAxios; 
app.use(Antd).mount('#app');
